/* eslint-disable react/jsx-filename-extension */
import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

const Main = ({ className, children }) => (
  <div
    className={classNames("main", className)}
    style={{ position: "relative" }}
  >
    {children}
  </div>
);

Main.defaultProps = {
  className: "",
};

Main.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
};

export default Main;
